export default "__VITE_ASSET__369264cd__"